import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Shell from "./components/Shell";
import { SessionProvider, useSession } from "./context/Session";
import { Banner } from "./components/ui";
import Dashboard from "./pages/Dashboard";
import Login, { AcceptInvite } from "./pages/Login";
import { AuditLogs, Approvals, Contractors, Emergency, Hosts, Kiosks, Reports, SettingsPage, Sites } from "./pages/Operations";
import { InviteVisitor, VisitDetail, VisitorList } from "./pages/Visitors";

function Gate() {
  const params = new URLSearchParams(window.location.search);
  const tokenHash = params.get("token_hash");
  const linkType = params.get("type");
  const [linkHandled, setLinkHandled] = useState(false);
  const { configured, session, profile, error } = useSession();
  if (!configured) return <Login />;
  if (tokenHash && !linkHandled) return <AcceptInvite tokenHash={tokenHash} type={linkType} onDone={() => setLinkHandled(true)} />;
  if (session === undefined) return <p className="p-8 text-sm">Loading session…</p>;
  if (!session) return <Login />;
  if (error) return <div className="p-8"><Banner>{error}</Banner></div>;
  if (!profile) return <p className="p-8 text-sm">Loading organization…</p>;
  if (!profile.membership) return <div className="p-8"><Banner>This account is not a member of a GLOBOVMS organization.</Banner></div>;
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Dashboard />} />
        <Route path="visitors" element={<VisitorList />} />
        <Route path="visitors/new" element={<InviteVisitor />} />
        <Route path="visitors/:id" element={<VisitDetail />} />
        <Route path="contractors" element={<Contractors />} />
        <Route path="hosts" element={<Hosts />} />
        <Route path="sites" element={<Sites />} />
        <Route path="kiosks" element={<Kiosks />} />
        <Route path="approvals" element={<Approvals />} />
        <Route path="emergency" element={<Emergency />} />
        <Route path="reports" element={<Reports />} />
        <Route path="audit" element={<AuditLogs />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return <SessionProvider><Gate /></SessionProvider>;
}
